import { AlertExpression } from "../../../proto/generated/nexus"
import { ChartAlertSnapshot } from "../alertModal.typings"

export type AlertExpressionDropdownProps = {
    expression: AlertExpression,
    chartSnapshot: ChartAlertSnapshot,
    comparedExpression: AlertExpression,
    mode: "lhs" | "rhs",
    onExpressionChange: (expression: AlertExpression, change: keyof AlertExpression) => void,
    onOutputChange: (output: string) => void,
    className?: string
}

export enum FixedExpressionOutputTypes {
    PRICE = "price",
    VOLUME = "volume",
    VALUE = "value"
}

export type DropdownOption = {
    label: string,
    value: string
}